import { BusinessType } from '@taxfyle/txf-api-client'

export const BUSINESS_TYPES_MAP: Record<BusinessType, string> = {
  [BusinessType.LLC]: 'Limited Liability Company (LLC)',
  [BusinessType.SoleProp]: 'Sole Proprietorship',
} as const

export const BUSINESS_TYPES = Object.entries(BUSINESS_TYPES_MAP) as [
  code: BusinessType,
  label: string,
][]
